import { useState, useContext, useEffect } from "react";
import { doSignIn } from "../../services/AuthService"
import { CurrentUserContext } from '../context/CurrentUserContext';
import { View, Message, Button, Flex, Label, Input, PasswordField, Text } from '@aws-amplify/ui-react';
import ReCAPTCHA from "react-google-recaptcha";


export const SignUp = ({ onSuccess, border = true }) => {
  const [input, setInput] = useState({
    username: "",
    password: "",
  });

  const [message, setMessage] = useState('');
  const [user, setUser] = useContext(CurrentUserContext);

  const [validation, setValidation] = useState({});


  useEffect(() => {
    console.log(validation);
  }, [validation])



  const handleSubmitEvent = async (e) => {
    e.preventDefault();

    console.log(validation);

  
    setValidation({'password2': 'true'})

   return false;

    if (input.email !== "" && input.password !== "") {

      setMessage('');

      var email = input.email;
      var password = input.password;

      try {
        var userData = await doSignIn({ email, password })

        setUser(userData);
        return;

      } catch (error) {

        if (error.response.status && error.response.status === 401) {
          // Handle 401
          setMessage("Bad credentials")
        } else {
          setMessage(error.message)
        }
        return;
      }


    }
    setMessage("please provide a valid input");
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  function onChange(value) {
    console.log("Captcha value:", value);
  }

  return (

    <ViewFrame border={false}>

      <h3>Sign Up</h3>

      <Flex as="form" direction="column" gap="0.5rem">

        <Label htmlFor="user-email" >Email</Label>
        <Input
          type="email"
          id="user-email"
          name="email"
          onChange={handleInput}
         //isRequired
        />

        <Label htmlFor="user-name" padding="0rem">Name</Label>
        <Input
          type="text"
          id="user-name"
          name="name"
          onChange={handleInput}
          //isRequired
        />

        <Label htmlFor="user-password">Password</Label>
        <PasswordField
          type="password"
          id="user-password"
          name="password"
          aria-describedby="user-password"
          aria-invalid="false"
          descriptiveText="Password must be at least 8 characters"
          onChange={handleInput}
         // isRequired
        />


        <Label htmlFor="user-password2">Repeat Password</Label>
        <PasswordField
          type="password"
          id="user-password2"
          name="password2"
          aria-describedby="user-password2"
          aria-invalid="false"
          onChange={handleInput}
          //isRequired
        />

        <Text variation="error" color={'red'}>Passwords must match.</Text>


        <Button type="submit" variation="primary" padding="1rem" margin={'20px 10px 10px 10px'} styles={{ margin: '10px' }} onClick={(e) => handleSubmitEvent(e)} >Submit</Button>

        <ReCAPTCHA
          sitekey="6LcB-pgpAAAAAKcL3geqoLAWFWr7jcVrI3RiFh1Z"
          onChange={onChange}
        />


{validation.password2  ?
        <Text variation="error" color={'red'}>Check Captcha.</Text> : <></>
}
       <p> -- {validation.password2}</p>

        {message != + '' ?
          <Message variation="filled" colorTheme="error" heading="Warning">
            {message}
          </Message> : <></>
        }
      </Flex>

    </ViewFrame>
  );
};






export const ViewFrame = ({ children, border }) => {


  return (

    <View
      as="div"
      ariaLabel="Sign Up"
      backgroundColor="var(--amplify-colors-white)"
      //backgroundColor="silver"
      borderRadius="6px"
      border="1px solid var(--amplify-colors-black)"
      boxShadow={border ? "3px 3px 5px 6px var(--amplify-colors-neutral-60)" : ""}
      color="var(--amplify-colors-blue-60)"
      // height="20rem"
      maxWidth="100rem"
      padding="1rem"
      width="25rem"
    >


      {children}

    </View>
  );
};


